import React, { SetStateAction, Dispatch } from "react";

type AcceptedProfiles = "ABIGAIL" | "JEREMY" | "MARK";

interface ButtonProps {
    redirection: Dispatch<SetStateAction<AcceptedProfiles | null>>;
    profile: AcceptedProfiles;
}

const ButtonGoProfile: React.FC<ButtonProps> = ({ redirection, profile })  => {
  return (
    <button
      className="stag_profile w-20 h-20 bg-buttonsMenu rounded-full absolute right-8 bottom-[-2rem] z-20 border-white border-4 flex justify-center items-center"
      onClick={() => redirection(profile)}
    >
      <img className="w-2/5" src="./assets/profiles/arrow.svg" />
    </button>
  );
};

export default ButtonGoProfile;
